package com.macrofocus.high_d

import com.macrofocus.high_d.parallelcoordinates.DefaultParallelCoordinatesController
import com.macrofocus.high_d.parallelcoordinates.DefaultParallelCoordinatesView
import com.macrofocus.high_d.parallelcoordinates.ParallelCoordinatesModel
import react.FC
import react.Props

@JsExport
external interface ParallelCoordinatesProps : Props {
    var model: ParallelCoordinatesModel<Int, String>?
}

@JsExport
val ParallelCoordinates = FC<ParallelCoordinatesProps> { props ->
//    val view = useMemo(props.model) {
        val view = DefaultParallelCoordinatesView<Int, String>()
//        view.getGeometry().value = Geometry.Polycurves
        //    component.getRendering().value = Rendering.AlphaBlended
        view.model = props.model
        DefaultParallelCoordinatesController<Int, String>(view)
//        view
//    }
    view.component.nativeComponent()
}
